import ComponentModule from "@eisinc/Overrides/Components/ProductUnitOfMeasureSelect";

export * from "@eisinc/Overrides/Components/ProductUnitOfMeasureSelect";

export default ComponentModule;
